module.exports = "pegasus/assets/blocks/column-18-theme4.png";